/** Brand constants (ADR D1, D17). */
export const PRODUCT_NAME = 'Pairing';
export const PRODUCT_LOCKUP = 'Pairing by Denamico';
export const POWERED_BY = 'Powered by Pairing by Denamico';
